export const ADMIN_API = "FlagshipBinding::admin_api";
